<script setup lang="ts">
/*
|--------------------------------------------------------------------------
| Punkt wejściowy do aplikacji
|--------------------------------------------------------------------------
*/
import { useAuthStore } from "./stores/authStore";

// Inicjalizacja AuthStore
const auth = useAuthStore();
</script>

<template>
    <router-view> </router-view>
</template>
